import { Enrollment } from "@api/types/enrollments";
import React, { FC } from "react";

import Button from "@components/Button";

const CourseDigitalWalletButton: FC<{ enrollment: Enrollment }> = ({ enrollment }) => {
  function onDigitalWalletButtonClick(enrollment: Enrollment) {
    window.location.href = enrollment.digitalWalletUrl;
  }

  return (
    <>
      {enrollment.digitalWalletUrl && enrollment.complete ? (
        <Button onClick={() => onDigitalWalletButtonClick(enrollment)}>
          Add Certificate to Digital Wallet
        </Button>
      ) : (
        <Button disabled={true}>Add Certificate to Digital Wallet</Button>
      )}
      {/* language=CSS */}
      <style jsx>
        {`
          .CourseDigitalWalletButton {
          }
        `}
      </style>
    </>
  );
};

export default CourseDigitalWalletButton;
